export const requiredValidator = {
  validate: (value) =>
    value?.toString().trim() !== "" || "This field is required",
};
